<script>
import {Doughnut} from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    asset: {},
    assetMonth: '',
  },
  watch: {
    assetMonth: function () {
      const chartData = {
        labels: this.asset.labels,
        datasets: [
          {
            label: 'My First Dataset',
            data: this.asset.data,
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(54, 162, 235)',
              'rgb(255, 205, 86)'
            ]
          }
        ],
      }

      const options = {}

      this.renderChart(chartData, options)
    }
  },
  created: function () {
  },
  mounted: function () {
    const chartData = {
      labels: this.asset.labels,
      datasets: [
        {
          label: 'My First Dataset',
          data: this.asset.data,
          backgroundColor: [
            'rgb(255, 99, 132)',
            'rgb(54, 162, 235)',
            'rgb(255, 205, 86)'
          ]
        }
      ],
    }

    const options = {}

    this.renderChart(chartData, options)
  }
}
</script>
